import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Refund = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="refund icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M14 6.95569C14 6.4034 13.5523 5.95569 13 5.95569C12.4477 5.95569 12 6.4034 12 6.95569V7.33472C11.6063 7.4414 11.2329 7.61713 10.9084 7.87255C10.2911 8.35842 9.91667 9.08527 9.91667 9.95569C9.91667 10.4745 10.0406 10.9405 10.2885 11.3374C10.5333 11.7296 10.8625 11.9962 11.1856 12.1785C11.7215 12.481 12.3492 12.5998 12.6932 12.665C12.7344 12.6728 12.7715 12.6798 12.8039 12.6863C13.195 12.7645 13.6664 12.866 14.0387 13.0766C14.3675 13.2628 14.5 13.4556 14.5 13.7612C14.5 14.0094 14.3973 14.2105 14.1706 14.3793C13.9239 14.5629 13.5205 14.7057 13 14.7057C11.9231 14.7057 11.5 14.0635 11.5 13.7612C11.5 13.209 11.0523 12.7612 10.5 12.7612C9.94772 12.7612 9.5 13.209 9.5 13.7612C9.5 15.2417 10.6682 16.2417 12 16.5794V16.9557C12 17.508 12.4477 17.9557 13 17.9557C13.5523 17.9557 14 17.508 14 16.9557V16.5959C14.4982 16.4826 14.9662 16.2804 15.3649 15.9835C16.0431 15.4786 16.5 14.7075 16.5 13.7612C16.5 12.5114 15.7575 11.7514 15.0238 11.3361C14.3516 10.9556 13.5957 10.8048 13.2251 10.7309L13.1961 10.7251C13.1564 10.7172 13.1177 10.7095 13.0799 10.702C12.6918 10.6252 12.4001 10.5674 12.1686 10.4367C12.0646 10.3781 12.0136 10.3241 11.985 10.2783C11.9594 10.2372 11.9167 10.1478 11.9167 9.95569C11.9167 9.6999 12.0086 9.55175 12.1453 9.44417C12.3071 9.31687 12.5938 9.20569 13 9.20569C13.623 9.20569 13.973 9.49847 14.0565 9.66159C14.3083 10.1531 14.9109 10.3475 15.4024 10.0957C15.894 9.84393 16.0884 9.24133 15.8366 8.74978C15.472 8.03798 14.7813 7.56063 14 7.34217V6.95569Z"
    />
    <path
      className={pathClass}
      d="M0.977487 9.95569H6.02251C6.89162 9.95569 7.32687 11.1301 6.71232 11.817L4.18981 14.6363C3.80884 15.0621 3.19116 15.0621 2.8102 14.6363L0.287682 11.817C-0.326868 11.1301 0.108382 9.95569 0.977487 9.95569Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 4C8.58172 4 5 7.58172 5 12C5 12.8284 4.32843 13.5 3.5 13.5C2.67157 13.5 2 12.8284 2 12C2 5.92487 6.92487 1 13 1C19.0751 1 24 5.92487 24 12C24 18.0751 19.0751 23 13 23C10.1061 23 7.47027 21.8805 5.50744 20.0537C4.90102 19.4893 4.86694 18.5402 5.43133 17.9338C5.99572 17.3273 6.94486 17.2933 7.55128 17.8577C8.98093 19.1882 10.894 20 13 20C17.4183 20 21 16.4183 21 12C21 7.58172 17.4183 4 13 4Z"
    />
  </svg>
)
